import { defaultRange, validateRange } from './rangeUtils';

export interface RecalculateParams {
  companyUuid: string;
  userProfileUuid: string;
  from: string;
  to: string;
}

export const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/** The URL is the source of truth for the form so a result can be shared as a link. */
export const parseParams = (search: URLSearchParams, today: Date): RecalculateParams => {
  const defaults = defaultRange(today);
  return {
    companyUuid: search.get('companyUuid') ?? '',
    userProfileUuid: search.get('userProfileUuid') ?? '',
    from: search.has('from') ? search.get('from')! : defaults.from,
    to: search.has('to') ? search.get('to')! : defaults.to
  };
};

/** from/to are always written (even empty) so clearing a date doesn't snap back to the default; uuids are omitted when empty. */
export const serializeParams = (p: RecalculateParams): URLSearchParams => {
  const out = new URLSearchParams();
  if (p.companyUuid) out.set('companyUuid', p.companyUuid);
  if (p.userProfileUuid) out.set('userProfileUuid', p.userProfileUuid);
  out.set('from', p.from);
  out.set('to', p.to);
  return out;
};

export const isComplete = (p: RecalculateParams): boolean => UUID_RE.test(p.companyUuid) && UUID_RE.test(p.userProfileUuid) && validateRange(p.from, p.to) === null;
